module.exports = __webpack_public_path__ + "img/73.cd910920.jpg";